import { render, staticRenderFns } from "./special-lib-ios.vue?vue&type=template&id=e38e2acc&scoped=true&"
import script from "./special-lib-ios.vue?vue&type=script&lang=ts&"
export * from "./special-lib-ios.vue?vue&type=script&lang=ts&"
import style0 from "./special-lib-ios.vue?vue&type=style&index=0&id=e38e2acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38e2acc",
  null
  
)

export default component.exports